import React, { Component } from 'react'

import EmMoviePanel from '../components/Em/EmMoviePanel.js'
import { Glyphicon } from 'react-bootstrap'
import PropTypes from 'prop-types'
import ResponsiveTable from '../components/Table/ResponsiveTable.js'
import { axios } from 'config/axios'
import { connect } from 'react-redux'
import { getContainerSize } from '../helpers/ResponsivenessHelper.js'
import { getEmMoviesByDataCollectionId } from '../api/ispyb.js'
import { processDataCollectionGroup } from '../actions/application.js'

class EmMovieContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fetching: true,
      fetched: false,
      movies: [],
      error: null,
    }
  }

  componentDidMount() {
    const _this = this

    axios({
      method: 'GET',
      url: getEmMoviesByDataCollectionId(_this.props.user, _this.props.proposal, _this.props.dataCollectionId),
    })
      .then(function (response) {
        _this.setState({
          movies: response.data,
          fetching: false,
          fetched: true,
        })
      })
      .catch(function (error) {
        _this.setState({
          error: error,
          fetching: false,
          fetched: false,
        })
      })
  }

  getColumns() {
    return [
      {
        text: 'Number',
        dataField: 'Movie_movieNumber',
        formatter: this.experimentFormatter,
        formatExtraData: this,
        sort: true,
        hidden: false,

        responsiveHeaderStyle: {},
      },
      {
        text: 'Time',
        dataField: 'Movie_createdTimeStamp',
        formatter: this.nameFormatter,
        formatExtraData: this,
        sort: true,
        hidden: false,

        responsiveHeaderStyle: {
          xs: { hidden: true },
          sm: { hidden: true },
        },
      },
      {
        text: 'Movie file name',
        dataField: 'Movie_fileName',
        formatter: this.beamlineFormatter,
        sort: true,
        responsiveHeaderStyle: {
          xs: { hidden: true },
          sm: { hidden: true },
        },
      },
      {
        text: 'Average motion/frame',
        dataField: 'MotionCorrection_averageMotionPerFrame',
        sort: true,
        responsiveHeaderStyle: {},
      },
      {
        text: 'Resolution',
        dataField: 'CTF_resolutionLimit',
        sort: true,
        formatter: this.datasetCountFormatter,
        formatExtraData: this,
        responsiveHeaderStyle: {},
      },
    ]
  }

  render() {
    const isExpanded = true
    const size = getContainerSize(window)

    const Expanded = class {
      constructor(_isExpanded) {
        this.isExpanded = _isExpanded
      }

      find() {
        return this.isExpanded
      }

      includes() {
        return this.isExpanded
      }
    }
    const expandRow = {
      showExpandColumn: true,
      expandByColumnOnly: false,
      expanded: new Expanded(isExpanded),
      expandColumnPosition: 'right',
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return (
            <span style={{ fontSize: '18px' }}>
              <Glyphicon glyph="zoom-out" />
            </span>
          )
        }
        return (
          <span style={{ fontSize: '18px' }}>
            <Glyphicon glyph="zoom-in" />
          </span>
        )
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return <Glyphicon glyph="zoom-out" />
        }
        return <Glyphicon glyph="zoom-in" />
      },
      renderer: movie => (
        <EmMoviePanel
          movieData={movie}
          user={this.props.user}
          proposal={this.props.proposal}
          dataCollectionId={this.props.dataCollectionId}
        />
      ),
    }
    return (
      <div style={{ marginBottom: '100px' }}>
        <strong>{getDirectory(this.state.movies, size)}</strong>
        <ResponsiveTable
          keyField="Movie_movieId"
          data={createImageNumberAndFileName(this.state.movies)}
          columns={this.getColumns()}
          expandRow={expandRow}
        />
      </div>
    )
  }
}

function stringDivider(str, width, spaceReplacer) {
  if (str.length > width) {
    let p = width
    for (; p > 0 && str[p] !== '/'; p--)
      if (p > 0) {
        const left = str.substring(0, p)
        const right = str.substring(p + 1)
        return left + spaceReplacer + stringDivider(right, width, spaceReplacer)
      }
  }
  return str
}

function getDirectory(movies, size) {
  if (movies.length > 0) {
    let width = 0
    const movieDirectory = movies[0].Movie_movieFullPath.substring(0, movies[0].Movie_movieFullPath.lastIndexOf('/'))
    switch (size) {
      case 'xs':
        width = 40
        break
      case 'sm':
        width = 60
        break
      case 'md':
        width = 80
        break
      case 'lg':
        width = 100
        break
      default:
        width = 200
    }
    return stringDivider('Directory : ' + movieDirectory, width, '/ ')
  }
}

function createImageNumberAndFileName(movies) {
  if (movies.length > 0) {
    movies.sort(function (a, b) {
      return a.Movie_movieId - b.Movie_movieId
    })
    const startMovieId = movies[0].Movie_movieId
    movies.forEach(function (element) {
      element.Movie_movieNumber = element.Movie_movieId - startMovieId + 1
      element.Movie_fileName = element.Movie_movieFullPath.substring(element.Movie_movieFullPath.lastIndexOf('/') + 1)
      const fileNameLength = element.Movie_fileName.length
      if (element.Movie_fileName.length > 25) {
        element.Movie_fileName =
          element.Movie_fileName.substring(0, 10) +
          '...' +
          element.Movie_fileName.substring(fileNameLength - 15, fileNameLength)
      }
    })
  }
  return movies.reverse()
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    processDataCollectionGroup: dataCollection => dispatch(processDataCollectionGroup(dataCollection)),
  }
}

EmMovieContainer.propTypes = {
  dataCollectionId: PropTypes.string,
  proposal: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(EmMovieContainer)
